import React from 'react';
import { ReceivingStatus } from '../ActiveReceivingPage';
import { AssetUrls } from 'config/assets';
import './ReceivingStatusTabs.css';

interface Props {
  activeTab: ReceivingStatus;
  onTabChange: (tab: ReceivingStatus) => void;
}

export default function ReceivingStatusTabs({ activeTab, onTabChange }: Props) {
  const tabs = [
    { 
      key: 'preparing' as ReceivingStatus, 
      label: 'Preparing to ship', 
      icon: AssetUrls.icons.misc.sendPackage
    },
    { 
      key: 'transit' as ReceivingStatus, 
      label: 'In Transit', 
      icon: `${AssetUrls.base}/assets/icons/SendCards/truck-in-transit.svg`
    },
    {
      key: 'completed' as ReceivingStatus,
      label: 'Completed',
      icon: `${AssetUrls.base}/assets/icons/SendCards/icon-completed.svg`
    },
    {
      key: 'cancelled' as ReceivingStatus,
      label: 'Cancelled',
      icon: `https://trademagic-assets.s3.us-west-1.amazonaws.com/assets/icons/cancelled.svg`
    }
  ];

  return (
    <div className="receiving-status-tabs">
      {tabs.map(tab => (
        <button
          key={tab.key}
          className={`status-tab ${activeTab === tab.key ? 'active' : ''}`}
          onClick={() => onTabChange(tab.key)}
        >
          <img 
            src={tab.icon} 
            alt={tab.label}
            className="tab-icon"
          />
          <span className="tab-label">{tab.label}</span>
        </button>
      ))}
    </div>
  );
}